"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MpApi = void 0;
var tslib_1 = require("tslib");
/* eslint-disable */
/* 此代码由工具自动生成,不要直接修改,以免下次生成会丢失 */
var di_1 = tslib_1.__importDefault(require("@jsmodules/di"));
var getApi_1 = tslib_1.__importDefault(require("../../getApi"));
var MpApi = /** @class */ (function () {
    function MpApi() {
        this.http = getApi_1.default('api_v1');
    }
    /**
     * 签名验证,通知请求
     * @method GET 签名验证
     * @method POST 通知请求
     *
     */
    MpApi.prototype.Mp = function () {
        return this.http
            .url("/api/Mp")
            .support('GET', 'POST');
    };
    MpApi.diOptions = di_1.default.options({
        name: "MpApi",
        scope: "Singleton"
    });
    return MpApi;
}());
exports.MpApi = MpApi;
exports.default = MpApi;
